import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import { TypeUtils } from '../../../../../framework/utils/UtilityTypes';
import { SaveButton } from '../../../../components/StyledButton';
import { useGlobalStateMachine } from '../../../../GlobalStore';
import { useEngeneNavigate } from '../../../../hooks/navigate';
import Detail, { DetailState } from './Detail';

/**
 * 経費詳細画面 新規作成モード
 * @returns
 */
const ExpenseDetailCreate: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();
  const navigate = useEngeneNavigate();
  const form = useFormContext<DetailState>();

  const [searchParams] = useSearchParams();
  React.useState(() =>
    form.reset({
      expense: {
        date: searchParams.get('date') || undefined,
        matterDate: searchParams.get('date') || undefined,
        matterId: TypeUtils.isNilString(searchParams.get('matterId'))
          ? undefined
          : parseInt(searchParams.get('matterId')!) || undefined,
        dailyMatterId: TypeUtils.isNilString(searchParams.get('dailyMatterId'))
          ? undefined
          : parseInt(searchParams.get('dailyMatterId')!) || undefined,
      },
    })
  );

  return (
    <Detail
      create
      matterSummary={state.pageInfo.MATTER_EXPENSE?.matterSummary}
      mode="edit"
    >
      <SaveButton
        onClick={() => {
          // TODO: save
          navigate();
        }}
      />
    </Detail>
  );
};

export default ExpenseDetailCreate;
